import _ from 'lodash';

function checkValidators(validators, model, actionKey) {
  return (_.get(validators, actionKey) || []).every((fn) => fn.call(null, model));
}

function checkValidatorsLazy(validators, actionKey) {
  return {
    check: (model) => checkValidators(validators, model, actionKey),
  };
}

function checkAccess(validators, model, actionKey = '', hasAccess = false) {
  if (hasAccess) {
    return hasAccess;
  }

  const newActionKey = actionKey.replace(/(-)/g, '.');
  return !!_.get(model.session.privileges, newActionKey) && checkValidators(validators, model, newActionKey);
}

function checkAccessLazy(validators, actionKey) {
  return {
    check: (model, hasAccess = false) => checkAccess(validators, model, actionKey, hasAccess),
  };
}

function retriveAction(appContext, actionKey) {
  return _.get(appContext.model, actionKey) || _.get(appContext.actions, actionKey) || (() => appContext.model);
}

function dispatch($timeout, validators, actionKey, hasAccess = false) {
  hasAccess = checkAccess(validators, this.model, actionKey, hasAccess); // eslint-disable-line no-param-reassign

  return {
    hasAccess,
    run: (...args) => {
      if (hasAccess) {
        this.busy = this.busy
          .then(() => retriveAction(this, actionKey)(...[this.model].concat(args)))
          .then((model) => $timeout(() => {
            this.model = model || this.model;
            return this.model;
          }))
          .catch((err) => {
            this.busy = Promise.resolve(this.model);
            throw _.get(err, 'data.code') ? new Error(err.data.code) : err;
          });
      }
      return this.busy;
    },
  };
}

export {
  dispatch, checkValidators, checkValidatorsLazy, checkAccess, checkAccessLazy,
};



// WEBPACK FOOTER //
// ./src/modules/rw-redux/action-dispatcher.js